import { observer } from "mobx-react";
import { Fragment, h } from "preact";
import { t, translate } from "../../I18n";
import NumericStepper from "../../components/NumericStepper";
import { adjustImage, makeImgUrl } from "../../utils/URL";
import CartItemDescription from "./CartItemDescription";
import CartItemPrice from "./CartItemPrice";
import AvailabilityDebugInfo from "../../components/AvailabilityDebugInfo";
import WeeklySchedulePopover from "./WeeklySchedulePopover";
const defaultImageUrn = "/uploads/media_library/3759b3df5982ce78756f289321cb79d3.png";
function CartProductItem(props) {
    const { item, isImageVisible, imageType, mode = "readonly" } = props;
    const { name, quantity, hasError } = item;
    const imageUrn = item.image || defaultImageUrn;
    const isEditable = mode == "editable";
    const isScheduleErrorVisible = item.error !== null &&
        item.error.type === "ScheduleUnavailability" &&
        item.weeklySchedule !== null;
    // TODO: multiple product view types ("CustomProductDetails" | "MenuProductDetails" | "MenuComboDetails")
    const productDetailsView = "MenuProductDetails";
    return (h("li", { class: `item ${hasError && "has-error"}` },
        h("div", { class: "cart-multi-column mobile" },
            isImageVisible && (h(CartItemImage, { urn: imageUrn, type: imageType, alt: name })),
            h("div", { class: "column info" },
                h(CartItemDetails, { item: item, type: productDetailsView, mode: mode }),
                h(CartItemError, { error: item.error }, isScheduleErrorVisible && (h(WeeklySchedulePopover, { id: item.id.value, weeklySchedule: item.weeklySchedule },
                    h("span", { class: "text-danger u-text-underline u-text-lowercase" },
                        "(",
                        translate(t.cart.showAvailability),
                        ")")))),
                h(AvailabilityDebugInfo, { fieldId: "produictInstance.availability", name: "ProductInstance", availability: item.availability })),
            h("div", { class: "column subtotal" },
                !hasError && h(CartItemPrice, { price: item.price }),
                isEditable && (h(NumericStepper, { quantity: quantity, onDecrement: () => item.decreaseQuantity(), onIncrement: () => item.increaseQuantity(), decrementAriaLabel: translate(t.theme_defaults.creator.stepper.decrease, {
                        name: name,
                        from: quantity.toString(),
                        to: Math.max(quantity - 1, 0).toString(),
                        price: "",
                    }), incrementAriaLabel: translate(t.theme_defaults.creator.stepper.increase, {
                        name: name,
                        from: quantity.toString(),
                        to: (quantity + 1).toString(),
                        price: "",
                    }) }))))));
}
const CartItemImage = (props) => {
    const { urn, alt, type = "square" } = props;
    const url = adjustImage({ w: 60, h: 60, crop: true }, makeImgUrl(urn !== null && urn !== void 0 ? urn : defaultImageUrn));
    const typeClass = type === "circle" ? "u-rounded-circle" : "u-border-radius";
    return (h("div", { class: "cart-items__dish-picture" },
        h("img", { src: url, class: `cart-items__dish-image cart-items__dish-image--new-cart ${typeClass}`, alt: alt })));
};
const CartItemDetails = (props) => {
    const { type, item, mode } = props;
    const name = mode === "editable" ? item.name : item.nameWithQuantity;
    /* TODO: check that name and choices are locale specific */
    /* TODO: different choices for MenuProductDetails with parts */
    /* TODO: different names forCustomProductDetails | MenuProductDetails with parts | MenuComboDetails */
    /* e.g. name for MenuComboDetails:
        $ intercalate " + "
        $ (\{ parts } -> intercalate " / " $ getLocalization locale <<< _.name <$> parts)
        <$> elements */
    switch (type) {
        case "CustomProductDetails":
        case "MenuComboDetails":
            return h("span", { class: "name" }, name);
        case "MenuProductDetails":
            return (h(Fragment, null,
                h("span", { class: "name" },
                    name,
                    " "),
                h("span", { class: "description" }, item.description),
                !item.isSinglePart && (h("ul", { class: "m-split-pizza-list" }, item.parts.map((part) => (h("li", { class: "m-split-pizza-list__item" },
                    part.name,
                    ":",
                    h(CartItemDescription, { text: part.description }))))))));
    }
};
const CartItemError = observer((props) => {
    const { error, children } = props;
    if (error === null) {
        return null;
    }
    return (h("div", null,
        h("span", { class: "text-danger" }, error.message),
        " ",
        children));
});
export default observer(CartProductItem);
